import { halfFull, esapi } from '@/mixin'
import { createNamespacedHelpers } from 'vuex'
const { mapActions: commonMapActions } = createNamespacedHelpers('common')
export default {
  mixins: [halfFull, esapi],

  methods: {
    ...commonMapActions(['kgibAddressCheck']),
    halfToFullAddrLane (v) {
      // return this.halfToFull(v)
      return this.checkEsapiRule(v, 'rule4')
    },
    halfToFullAddrNum (v) {
      /*
      const regEx = /^\d{1,8}[之-]{1}\d{1,8}$/
      let n = this.fullToHalf(v)
      if (n.match(regEx)) {
        n = this.halfToFull(v)
        return n
      }
      return this.halfToFullNum(v)
      */

      // 做法二：先找之、-。有找到時，分成之、- 前面的字串和後面的字串，只保留數字再併起來
      // 沒找到之、-時，只保留數字
      if (!v) return ''
      const splitStr1 = '之'
      const splitStr2 = '-'
      let splitStr = ''
      let n = -1
      let n1 = v.indexOf(splitStr1)
      let n2 = v.indexOf(splitStr2)
      if (n1 > 0 && n2 > 0) {
        if (n1 <= n2) {
          n = n1
          splitStr = splitStr1
        } else {
          n = n2
          splitStr = splitStr2
        }
      } else if (n1 > 0) {
        n = n1
        splitStr = splitStr1
      } else if (n2 > 0) {
        n = n2
        splitStr = splitStr2
      }

      if (n <= 0) { // 不存在 之、-
        return this.halfToFullNum(v)
      }
      // 有之、-時，分成 之、- 之前的字串和之後的字串，只保留數字再併起來
      let v1 = this.halfToFullNum(v.substring(0, n))
      let v2 = ''
      if (v.length > n+1) {
        v2 = this.halfToFullNum(v.substring(n+1))
      }
      if (v2) {
        return v1 + this.halfToFull(splitStr) + v2
      } else {
        return v1
      }

    },
    halfToFullLaneAlleyNum (v) {
      // 沒找到之時，只保留數字
      if (!v) return ''
      const splitStr1 = '之'
      let splitStr = ''
      let n = -1
      let n1 = v.indexOf(splitStr1)
      if (n1 > 0) {
        n = n1
        splitStr = splitStr1
      }
      if (n <= 0) { // 不存在 之
        return this.halfToFullNum(v)
      }
      // 有之時，分成 之 之前的字串和之後的字串，只保留數字再併起來
      let v1 = this.halfToFullNum(v.substring(0, n))
      let v2 = ''
      if (v.length > n+1) {
        v2 = this.halfToFullNum(v.substring(n+1))
      }
      if (v2) {
        return v1 + this.halfToFull(splitStr) + v2
      } else {
        return v1
      }

    },
    halfToFullNum (v) {
      let n = this.number(v)
      n = this.halfToFull(n)
      return n
    },
    hasStatusCode13 (v) {
      if (!(v.resultAnalysis && v.resultAnalysis.statusCode && v.resultAnalysis.statusCode.length > 0)) {
        return false
      }
      let flag = false
      v.resultAnalysis.statusCode.forEach(e => {
        if (e === 13) {
          flag = true
        }
      })
      return flag
    },
    getResultFullAddress (v) {
      let address = {}
      address.addrZipCode = (v.postcode3)?v.postcode3:''
      address.addrCity = (v.city)?v.city:''
      address.addrArea = (v.town)?v.town:''

      if (v.road) {
        address.addrRoad = v.road
      } else if (v.hamlet) {
        address.addrRoad = v.hamlet
      } else if (v.village) {
        address.addrRoad = v.village
      } else {
        address.addrRoad = ''
      }


      let num = (v.lane)?v.lane:''
      if (num.length > 0) {
        let n = num.indexOf('巷')
        if (n > 0) {
          address.addrLane = this.halfToFullAddrLane(num.substring(0, n))
        } else {
          address.addrLane = ''
        }
      } else {
        address.addrLane = ''
      }

      num = (v.alley)?v.alley:''
      if (num.length > 0) {
        let n = num.indexOf('弄')
        if (n > 0) {
          address.addrAlley = this.halfToFullAddrNum(num.substring(0, n))
        } else {
          address.addrAlley = ''
        }
      } else {
        address.addrAlley = ''
      }

      num = (v.lon)?v.lon:''
      if (num.length > 0) {
        let n = num.indexOf('衖')
        if (n > 0) {
          address.addrLon = this.halfToFullNum(num.substring(0, n))
        } else {
          address.addrLon = ''
        }
      } else {
        address.addrLon = ''
      }

      num = (v.num)?v.num:''
      if (num.length > 0) {
        let n = num.indexOf('號')
        if (n > 0) {
          address.addrNum = this.halfToFullAddrNum(num.substring(0, n))
          num = num.substring(n+1)
        } else {
          address.addrNum = ''
          num = ''
        }
        n = num.indexOf('之')
        if (n >= 0) {
          address.addrNumOf = this.halfToFullNum(num.substring(n+1))
        } else {
          address.addrNumOf = ''
        }
      } else {
        address.addrNum = ''
        address.addrNumOf = ''
      }

      num = (v.floor)?v.floor:''
      if (num.length > 0) {
        let n = num.indexOf('之')
        if (n < 0) {
          let m = num.indexOf('樓')
          if (m > 0) {
            address.addrFloor = num.substring(0, m)
            // 可能出現 五樓3 ，沒有之的狀況
            if (m < num.length-1) {
              // 取樓後面填入 addrFloorOf
              address.addrFloorOf = this.halfToFullNum(num.substring(m+1))
            }
          }
        } else {
          address.addrFloor = num.substring(0, n)
          address.addrFloorOf = this.halfToFullNum(num.substring(n+1))
        }

        if (address.addrFloor) {
          address.addrFloor = address.addrFloor.replace('樓', '')
        }
      } else {
        address.addrFloor = ''
        address.addrFloorOf = ''
      }
      return address
    },
    getFullAddress (address) {
      return ((address.addrCity)?address.addrCity:'') +
            ((address.addrArea)?address.addrArea:'') +
            ((address.addrRoad)?address.addrRoad:'') +
            ((address.addrLane)?(address.addrLane + '巷'): '') +
            ((address.addrAlley)?(address.addrAlley + '弄'): '') +
            ((address.addrLon)?(address.addrLon + '衖'): '') +
            ((address.addrNum)?(address.addrNum + '號'): '') +
            ((address.addrNumOf)?('之' + address.addrNumOf): '') +
            ((address.addrFloor)?((this.isNotUnderground(address.addrFloor))?(address.addrFloor + '樓'):address.addrFloor): '') +
            ((address.addrFloorOf)?('之' + address.addrFloorOf): '')
    },
    isNotUnderground(val) {
      if (val.startsWith('地') || val.startsWith('底')) {
        return false
      }
      return true
    },
    removeZipCode (addr) {
      const regex = /^\d+\s*/
      return addr.replace(regex, '')
    },
    addressCheck (addr, transCode, compCode) {
      // 去除addr 前的郵遞區號
      addr = this.removeZipCode(addr)
      return this.kgibAddressCheck({address: addr, transCode, compCode}).then(r => {
        let ret = {
          connectError: false,
          code: '',
          msg: '',
          address: {},
          resultAddr: ''
        }

        // r.data.exists = 'Y'
        // r.data.isLatest = 'N'

        if (r.data.connectError) {
          // 連線錯誤
          ret.connectError = true
          return ret
        } else if (r.data.status !== 'OK') {
          ret.code = 'error1'
          ret.msg = '地址正規化檢核失敗，請重新輸入！'
          return ret
        }
        if (r.data.exists === 'Y') {
          let hasStatusCode13 = this.hasStatusCode13(r.data)

          if (r.data.isLatest === 'Y' || (r.data.isLatest === 'N' && !hasStatusCode13)) {
            if (!(r.data.rawResponse && r.data.rawResponse.results &&
              r.data.rawResponse.results.length > 0 && r.data.rawResponse.results[0])) {
              ret.code = 'error2'
              ret.msg = '地址門牌回傳內容錯誤！'
              return ret
            }
            let address = this.getResultFullAddress(r.data.rawResponse.results[0])
            ret.code = 'ok1'
            ret.msg = ''
            ret.address = address

            return ret
          }
        }
        if (r.data.exists === 'Y' && r.data.isLatest === 'N') {
          let hasStatusCode13 = this.hasStatusCode13(r.data)

          if (hasStatusCode13) {
            if (!(r.data.rawResponse && r.data.rawResponse.results &&
              r.data.rawResponse.results.length > 0 && r.data.rawResponse.results[0])) {
              ret.code = 'error2'
              ret.msg = '地址門牌回傳內容錯誤！'
              return ret
            }
            let address = this.getResultFullAddress(r.data.rawResponse.results[0])
            let fullAddr = address.addrZipCode + ' ' + this.getFullAddress(address)
            ret.code = 'ok2'
            ret.msg = '地址門牌整編過，新地址為:' + fullAddr
            ret.address = address
            ret.resultAddr = fullAddr

            return ret
          }

        }
        if (r.data.exists === 'N' && r.data.isLatest === 'N') {
          ret.code = 'error3'
          ret.msg = '輸入的地址門牌不存在，請重新輸入！'
          return ret
        } if (r.data.exists === 'N' && r.data.isLatest === 'Y') {
          ret.code = 'error3'
          let refAddr = (r.data.latestAddr)?r.data.latestAddr:''
          const addrSet = new Set()
          addrSet.add(refAddr)

          if (r.data.rawResponse && r.data.rawResponse.results &&
            r.data.rawResponse.results.length > 0) {
              r.data.rawResponse.results.forEach(e => {
                if (e.formatted_address) {
                  addrSet.add(e.formatted_address)
                }
              })
          }
          refAddr = [...addrSet].join('、')

          ret.msg = '<div style="text-align:left">輸入的地址門牌不存在，請重新輸入！參考地址如下：</div>' + refAddr
          return ret
        } else {
          ret.code = 'error4'
          ret.msg = '輸入的地址門牌不存在，請重新輸入！'
          return ret
        }

      })
    }
  }

}
